import { render } from "./projectComp.vue?vue&type=template&id=fe407254"
import script from "./projectComp.vue?vue&type=script&lang=js"
export * from "./projectComp.vue?vue&type=script&lang=js"

import "./projectComp.vue?vue&type=style&index=0&id=fe407254&lang=css"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__